export function getUrl() {
  let url
  const env = getEnv()
  if (env === "development" || env === "local") {
    url = 'https://wpdataservice-dev.wisepay.com.br/'
  } else if (window.location.href.split('.')[0].includes('-hml')) {
    url = 'https://wpdataservice-hml.wisepay.com.br/'
  } else {
    url = 'https://wpdataservice.wisepay.com.br/'
  }
  return url
}

export function getUrlNotify() {
  let url
  const env = getEnv()
  if (env === "development" || env === "local") {
    url = 'https://wpnotify-dev.wisepay.com.br/'
  } else if (window.location.href.split('.')[0].includes('-hml')) {
    url = 'https://wpnotify-hml.wisepay.com.br/'
  } else {
    url = 'https://wpnotify.wisepay.com.br/'
  }
  return url
}

export function getOrgIdAntifraud() {
  let orgId
  const env = getEnv()
  if (env === "development" || env === "local") {
    orgId = '1snn5n9w'
  } else if (window.location.href.split('.')[0].includes('-hml')) {
    orgId = '1snn5n9w'
  } else {
    orgId = 'k8vif92e'
  }
  return orgId
}

export function getEnv() {
  const href = window.location.href
  const subdomain = href.split('.')[0]

  if (subdomain.includes('dev') || href.includes('vercel.app')) {
    return 'development'
  }

  if (href.includes('localhost')) {
    return 'local'
  }

  if (subdomain.includes('-hml')) {
    return 'homologation'
  }

  return 'production'
}